/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".mat-form-field[_ngcontent-%COMP%]{width:95%}.form-container[_ngcontent-%COMP%]{margin-top:6.3px}#disclaimer[_ngcontent-%COMP%]{margin-bottom:6.3px}"];
export { styles as styles };
